import styled from "styled-components";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";

import Button from "@/components/Button";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import SearchesTable from "./components/SearchesTable";
import NewSearchModal from "./components/NewSearchModal";

const HeadingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
`;

const NewPostButton = styled(Button)`
  padding: 0 32px;
`;

const AmazonList = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Text $type="caption" $color="gray">
        EDITORIAL
      </Text>
      <HeadingsRow>
        <PageHeading>Amazon Products SERP</PageHeading>
        <NewPostButton onClick={() => setShowModal(true)}>
          New search
        </NewPostButton>
      </HeadingsRow>
      <SearchesTable />
      <AnimatePresence>
        {!!showModal && <NewSearchModal onClose={() => setShowModal(false)} />}
      </AnimatePresence>
    </>
  );
};

export default AmazonList;
